{
    "advanced": {
        "action_list": "动作列表",
        "helpers": "辅助器",
        "hide": "隐藏",
        "loading_workers": "加载工作器中",
        "run": "运行",
        "show": "显示",
        "sim_options": "模拟选项",
        "substat_helper": "副属性辅助器",
        "workers_available": "可用工作器："
    },
    "artifact_names": {
        "archaicpetra": "悠古的磐岩",
        "berserker": "战狂",
        "blizzardstrayer": "冰风迷途的勇士",
        "bloodstainedchivalry": "染血的骑士道",
        "braveheart": "勇士之心",
        "crimsonwitchofflames": "炽烈的炎之魔女",
        "defenderswill": "守护之心",
        "emblemofseveredfate": "绝缘之旗印",
        "gambler": "赌徒",
        "gladiatorsfinale": "角斗士的终幕礼",
        "heartofdepth": "沉沦之心",
        "huskofopulentdreams": "华馆梦醒形骸记",
        "instructor": "教官",
        "lavawalker": "渡过烈火的贤人",
        "maidenbeloved": "被怜爱的少女",
        "martialartist": "武人",
        "noblesseoblige": "昔日宗室之仪",
        "oceanhuedclam": "海染砗磲",
        "paleflame": "苍白之火",
        "prayersfordestiny": "祭水之人",
        "prayersforillumination": "祭火之人",
        "prayersforwisdom": "祭雷之人",
        "prayerstospringtime": "祭冰之人",
        "resolutionofsojourner": "行者之心",
        "retracingbolide": "逆飞的流星",
        "scholar": "学士",
        "shimenawasreminiscence": "追忆之注连",
        "tenacityofthemillelith": "千岩牢固",
        "theexile": "流放者",
        "thunderingfury": "如雷的盛怒",
        "thundersoother": "平息鸣雷的尊者",
        "tinymiracle": "奇迹",
        "viridescentvenerer": "翠绿之影",
        "wandererstroupe": "流浪大地的乐团"
    },
    "character": {
        "artifact_stats": "圣遗物属性",
        "c_post": "命",
        "c_pre": "",
        "lvl": "等级",
        "talents": "天赋"
    },
    "characteredit": {
        "add_set_bonus": "添加套装效果",
        "anemo": "风元素伤害加成",
        "artifact_stats_main": "圣遗物属性（主词条+副词条）",
        "ascension": "突破",
        "atk_atk": "攻击力",
        "attack": "普通攻击",
        "burst": "元素爆发",
        "cd": "暴击伤害",
        "change": "更换",
        "character": "角色",
        "cons": "命之座",
        "cr": "暴击率",
        "cryo": "冰元素伤害加成",
        "def_def": "防御力",
        "electro": "雷元素伤害加成",
        "em": "元素精通",
        "er": "元素充能效率",
        "geo": "岩元素伤害加成",
        "heal": "治疗加成",
        "hp_hp": "生命值",
        "hydro": "水元素伤害加成",
        "level": "等级",
        "phy": "物理伤害加成",
        "pyro": "火元素伤害加成",
        "refine": "精炼",
        "set_bonus": "套装效果：",
        "skill": "元素战技",
        "weapons_and_artifacts": "武器和圣遗物"
    },
    "character_names": {
        "aether": "空",
        "lumine": "荧",
        "albedo": "阿贝多",
        "aloy": "埃洛伊",
        "amber": "安柏",
        "barbara": "芭芭拉",
        "beidou": "北斗",
        "bennett": "班尼特",
        "chongyun": "重云",
        "diluc": "迪卢克",
        "diona": "迪奥娜",
        "eula": "优菈",
        "fischl": "菲谢尔",
        "ganyu": "甘雨",
        "hutao": "胡桃",
        "jean": "琴",
        "kazuha": "枫原万叶",
        "kaeya": "凯亚",
        "ayaka": "神里绫华",
        "keqing": "刻晴",
        "klee": "可莉",
        "sara": "九条裟罗",
        "lisa": "丽莎",
        "mona": "莫娜",
        "ningguang": "凝光",
        "noelle": "诺艾尔",
        "qiqi": "七七",
        "raiden": "雷电将军",
        "razor": "雷泽",
        "rosaria": "罗莎莉亚",
        "kokomi": "珊瑚宫心海",
        "sayu": "早柚",
        "sucrose": "砂糖",
        "tartaglia": "达达利亚",
        "thoma": "托马",
        "venti": "温迪",
        "xiangling": "香菱",
        "xiao": "魈",
        "xingqiu": "行秋",
        "xinyan": "辛焱",
        "yanfei": "烟绯",
        "yoimiya": "宵宫",
        "zhongli": "钟离",
        "gorou": "五郎",
        "itto": "荒泷一斗",
        "shenhe": "申鹤",
        "yunjin": "云堇",
        "yaemiko": "八重神子"
    },
    "components": {
        "close": "关闭",
        "currently_loaded_workers": "当前加载的工作器：",
        "no_characters": "没有角色",
        "result_post": "毫秒，平均DPS：",
        "result_pre": "模拟完成，用时",
        "running_simulation": "正在运行模拟：",
        "see_results_in": "在视图中查看结果",
        "set": "设置",
        "simulation_exited_with": "模拟中发生了错误：",
        "workers_post": "个工作器运行模拟",
        "workers_pre": "正在使用"
    },
    "dash": {
        "about": "关于",
        "advanced_mode": "进阶模式",
        "contribute": "合作开发",
        "desktop_tool": "桌面版工具",
        "documentation": "文档",
        "is_a_team": "是一个原神配队DPS模拟器。快点击下面的一个选项开始吧！",
        "simulator": "模拟器",
        "teams_db": "配队数据库",
        "viewer": "视图"
    },
    "db": {
        "author": "作者：",
        "average_dps_per": "平均DPS：",
        "c_post": "命",
        "c_pre": "",
        "cancel": "取消",
        "character": "角色",
        "continue": "继续",
        "description": "描述：",
        "details": "详情",
        "er": "元素充能效率：",
        "error_loading_database": "加载数据库失败。找不到数据",
        "filters": "过滤器：",
        "hash": "哈希：",
        "load_in_simulator": "加载到模拟器",
        "loading": "加载中……",
        "number_of_targets": "目标数：",
        "r": " 精",
        "show_in_viewer": "在视图中展示",
        "total_dps": "总DPS：",
        "type_to_search": "搜索…",
        "weapon": "武器"
    },
    "footer": {
        "gcsim_is_not": "gcsim不是官方工具，原神的游戏内容和素材的商标和版权归米哈游所有。本网站的国际化汉化支持来自：古月浪子。"
    },
    "elements": {
        "none": "无属性",
        "anemo": "风属性",
        "geo": "岩属性",
        "pyro": "火属性",
        "cryo": "冰属性",
        "hydro": "水属性",
        "electro": "雷属性",
        "dendro": "草属性"
    },
    "links": {
        "error_loading_database": "加载数据库失败。找不到数据"
    },
    "importer": {
        "import_success": "GOOD信息库已成功上载"
    },
    "nav": {
        "about": "关于",
        "advanced": "进阶",
        "chinese": "中文",
        "english": "English",
        "japanese": "日本語",
        "spanish": "Español",
        "language": "语言：",
        "simulator": "模拟器",
        "teams_db": "配队数据库",
        "viewer": "视图"
    },
    "sim": {
        "loading_simulator_please": "加载模拟器中。请稍候"
    },
    "simple": {
        "action_list": "动作列表",
        "add_character": "添加角色",
        "discord_post": "上有大量用户提交的动作列表可供参考。",
        "discord_pre": "在下面的文本框中输入你希望使用的动作列表。我们在",
        "documentation": "文档",
        "documentation_post": "，其中包含有关如何编写顺序列表（以前称为计算模式）的简单教程。",
        "documentation_pre": "或者，查看我们的",
        "done": "完成",
        "exit_edit": "退出编辑",
        "give_me_back": "将我的小提示还回来！",
        "hide": "隐藏",
        "hide_all_tips": "隐藏所有小提示",
        "loading_workers": "加载工作器中",
        "run": "运行",
        "show": "显示",
        "sim_options": "模拟选项",
        "start_by_adding": "快开始添加队伍成员吧",
        "team": "配队",
        "video": "视频",
        "video_post": "来了解更多。",
        "video_pre": "开始添加角色到你的队伍中吧。查看这个",
        "workers_available": "可用工作器："
    },
    "src": {
        "this_page_is": "此页面正在施工中。敬请期待！"
    },
    "viewer": {
        "ability_usage_count": "天赋使用次数（平均）",
        "api_key_supporters": "API密钥（仅限支持者）",
        "attack": "攻击力",
        "average_character_field": "角色平均站场时间",
        "average_dps_by": "角色平均DPS",
        "avg_dps": "平均DPS",
        "built_on": "，时间：",
        "cancel": "取消",
        "cd": "暴击伤害",
        "clear": "清空",
        "close": "关闭",
        "combined": "合计",
        "config": "配置",
        "continue": "继续",
        "copied_to_clipboard": "复制到剪切板",
        "copy": "复制",
        "copy_link": "复制链接",
        "cr": "暴击率",
        "create_a_shareable": "创建分享链接",
        "damage_dealt_over": "伤害随时间的分布",
        "debug": "调试",
        "debug_settings": "调试设置",
        "defaults": "恢复默认",
        "defense": "防御力",
        "details": "详情",
        "dps_by_ability": "天赋DPS（平均）",
        "em": "元素精通",
        "er": "元素充能效率",
        "error_copying_not": "复制失败 :( 不确定为什么出问题了",
        "error_encountered": "发生错误：",
        "git_hash": "git哈希：",
        "hp": "生命值",
        "level": "等级",
        "link_is_permanent": "链接是永久的。",
        "link_post": "可在此处查看结果：",
        "link_pre": "上传成功。",
        "link_will_expire": "链接将会在7天后过期。",
        "load_this_configuration": "在进阶模式加载此配置",
        "log_options": "日志选项",
        "make_link_permanent": "使链接永久化？",
        "note_that_by": "请注意，默认情况下分享链接仅在7天内有效。这样做是为了将服务器存储使用率保持在合理的水平。贡献者和Ko-Fi支持者可以输入私钥以使他们的链接永久化。",
        "particles_count": "元素晶球数",
        "please_note_that": "请注意，这并不是试图让人们捐款。这是一种控制共享数据量的简单方法，同时对那些在经济上或通过贡献支持该项目的人表示感谢。如果你确实需要一个永久链接并且你没有访问密钥，只需跳到我们的Discord并请别人为你代做。",
        "reactions_triggered": "触发的反应",
        "refinement": "精炼",
        "sec_post": "秒的战斗（",
        "sec_pre": "模拟了",
        "send_to_simulator": "发送到模拟器",
        "share": "分享",
        "substats": "副属性",
        "summary": "摘要",
        "target": "目标",
        "this_will_overwrite": "这将覆盖你可能拥有的任何现有配置。你确定要继续吗？",
        "time_post": "秒运行）。",
        "time_pre": "次迭代使用了",
        "unknown": "未知",
        "upload": "上传",
        "upload_failed": "上传失败"
    },
    "viewerdashboard": {
        "drag_n_drop": "拖动gcsim的gzip-JSON文件到此处，或者点击以选择",
        "drop_the_file": "将文件拖动到此处…",
        "error_retrieving_specified": "检索指定URL失败",
        "or_select_from": "或者选择之前打开过的文件（页面重载时将会被删除）：",
        "upload_a_file": "上传文件",
        "url_does_not": "无效的gzip-JSON文件URL"
    },
    "weapon_names": {
        "akuoumaru": "恶王丸",
        "alleyhunter": "暗巷猎手",
        "amenomakageuchi": "天目影打刀",
        "amosbow": "阿莫斯之弓",
        "apprenticesnotes": "学徒笔记",
        "aquilafavonia": "风鹰剑",
        "beginnersprotector": "新手长枪",
        "blackcliffagate": "黑岩绯玉",
        "blackclifflongsword": "黑岩长剑",
        "blackcliffpole": "黑岩刺枪",
        "blackcliffslasher": "黑岩斩刀",
        "blackcliffwarbow": "黑岩战弓",
        "blacktassel": "黑缨枪",
        "bloodtaintedgreatsword": "沐浴龙血的剑",
        "calamityqueller": "息灾",
        "cinnabarspindle": "辰砂之纺锤",
        "compoundbow": "钢轮弓",
        "coolsteel": "冷刃",
        "crescentpike": "流月针",
        "darkironsword": "暗铁剑",
        "deathmatch": "决斗之枪",
        "debateclub": "以理服人",
        "dodocotales": "嘟嘟可故事集",
        "dragonsbane": "匣里灭辰",
        "dragonspinespear": "龙脊长枪",
        "dullblade": "无锋剑",
        "elegyfortheend": "终末嗟叹之诗",
        "emeraldorb": "翡玉法球",
        "engulfinglightning": "薙草之稻光",
        "everlastingmoonglow": "不灭月华",
        "eyeofperception": "昭心",
        "favoniuscodex": "西风秘典",
        "favoniusgreatsword": "西风大剑",
        "favoniuslance": "西风长枪",
        "favoniussword": "西风剑",
        "favoniuswarbow": "西风猎弓",
        "ferrousshadow": "铁影阔剑",
        "festeringdesire": "腐殖之剑",
        "filletblade": "吃虎鱼刀",
        "freedomsworn": "苍古自由之誓",
        "frostbearer": "忍冬之果",
        "hakushinring": "白辰之环",
        "halberd": "钺矛",
        "hamayumi": "破魔之弓",
        "harbingerofdawn": "黎明神剑",
        "huntersbow": "猎弓",
        "ironpoint": "铁尖枪",
        "ironsting": "铁蜂刺",
        "kagurasverity": "神乐之真意",
        "katsuragikirinagamasa": "桂木斩长正",
        "kitaincrossspear": "喜多院十文字",
        "lionsroar": "匣里龙吟",
        "lithicblade": "千岩古剑",
        "lithicspear": "千岩长枪",
        "lostprayertothesacredwinds": "四风原典",
        "luxurioussealord": "衔珠海皇",
        "magicguide": "魔导绪论",
        "mappamare": "万国诸海图谱",
        "memoryofdust": "尘世之锁",
        "messenger": "信使",
        "mistsplitterreforged": "雾切之回光",
        "mitternachtswaltz": "幽夜华尔兹",
        "mouunsmoon": "曚云之月",
        "oathsworneye": "证誓之明瞳",
        "oldmercspal": "佣兵重剑",
        "otherworldlystory": "异世界行记",
        "pocketgrimoire": "口袋魔导书",
        "polarstar": "冬极白星",
        "predator": "掠食者",
        "primordialjadecutter": "磐岩结绿",
        "primordialjadewingedspear": "和璞鸢",
        "prototypeamber": "试作金珀",
        "prototypearchaic": "试作古华",
        "prototypecrescent": "试作澹月",
        "prototyperancour": "试作斩岩",
        "prototypestarglitter": "试作星镰",
        "rainslasher": "雨裁",
        "ravenbow": "鸦羽弓",
        "recurvebow": "反曲弓",
        "redhornstonethresher": "赤角石溃杵",
        "royalbow": "宗室长弓",
        "royalgreatsword": "宗室大剑",
        "royalgrimoire": "宗室秘法录",
        "royallongsword": "宗室长剑",
        "royalspear": "宗室猎枪",
        "rust": "弓藏",
        "sacrificialbow": "祭礼弓",
        "sacrificialfragments": "祭礼残章",
        "sacrificialgreatsword": "祭礼大剑",
        "sacrificialsword": "祭礼剑",
        "seasonedhuntersbow": "历练的猎弓",
        "serpentspine": "螭骨剑",
        "sharpshootersoath": "神射手之誓",
        "silversword": "银剑",
        "skyridergreatsword": "飞天大御剑",
        "skyridersword": "飞天御剑",
        "skywardatlas": "天空之卷",
        "skywardblade": "天空之刃",
        "skywardharp": "天空之翼",
        "skywardpride": "天空之傲",
        "skywardspine": "天空之脊",
        "slingshot": "弹弓",
        "snowtombedstarsilver": "雪葬的星银",
        "solarpearl": "匣里日月",
        "songofbrokenpines": "松籁响起之时",
        "staffofhoma": "护摩之杖",
        "summitshaper": "斫峰之刃",
        "swordofdescension": "降临之剑",
        "thealleyflash": "暗巷闪光",
        "thebell": "钟剑",
        "theblacksword": "黑剑",
        "thecatch": "「渔获」",
        "theflute": "笛剑",
        "thestringless": "绝弦",
        "theunforged": "无工之剑",
        "theviridescenthunt": "苍翠猎弓",
        "thewidsith": "流浪乐章",
        "thrillingtalesofdragonslayers": "讨龙英杰谭",
        "thunderingpulse": "飞雷之弦振",
        "travelershandysword": "旅行剑",
        "twinnephrite": "甲级宝珏",
        "vortexvanquisher": "贯虹之槊",
        "wastergreatsword": "训练大剑",
        "wavebreakersfin": "断浪长鳍",
        "whiteblind": "白影剑",
        "whiteirongreatsword": "白铁大剑",
        "whitetassel": "白缨枪",
        "windblumeode": "风花之颂",
        "wineandsong": "暗巷的酒与诗",
        "wolfsgravestone": "狼的末路"
    }
}